// extracted by mini-css-extract-plugin
module.exports = {"whatsapp-consent-wrapper":"SignupWhatsappConsent_whatsapp-consent-wrapper__v1sKX","text":"SignupWhatsappConsent_text__Xq93r"};